import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { SuggestionsList, SuggestionsListVariant } from 'components/DestinationPickerOverlay/SuggestionsList';
import { OnDestinationChangeParams, RecentSearchParams } from 'hooks/searchBox';
import { getIsRtlLanguage } from 'modules/meta/selectors';
import { Popover, PopoverPlacement } from '@daedalus/atlas/Popover';
import { POPOVER_HORIZONTAL_OFFSET, POPOVER_VERTICAL_OFFSET } from '@daedalus/shared/src/search/constants';
interface Props {
  isOpen: boolean;
  onClose: (e: MouseEvent) => void;
  onForceClosePopover?: () => void;
  onChange: (params: OnDestinationChangeParams) => void;
  onRecentSearchSelected: (params: RecentSearchParams) => void;
  onSuggestionSelected: () => void;
  onNearbyPropertiesSuggestionSelected: () => void;
  anchorRef: React.RefObject<HTMLElement>;
}
const PopoverContent = /*#__PURE__*/styled('div')({
  name: "PopoverContent",
  class: "piexl2u",
  propsAsIs: false
});
export const DestinationPickerPopover = ({
  isOpen,
  onClose,
  onForceClosePopover,
  onChange,
  onRecentSearchSelected,
  onSuggestionSelected,
  anchorRef,
  onNearbyPropertiesSuggestionSelected
}: Props) => {
  const isRtl = useSelector(getIsRtlLanguage);
  return <Popover isOpen={isOpen} anchorRef={anchorRef} verticalOffset={POPOVER_VERTICAL_OFFSET} horizontalOffset={POPOVER_HORIZONTAL_OFFSET} onOutsideClick={onClose} placement={isRtl ? PopoverPlacement.Right : PopoverPlacement.Left}>
      <PopoverContent>
        <SuggestionsList listType={SuggestionsListVariant.Popover} onChange={onChange} onSuggestionSelected={onSuggestionSelected} onRecentSearchSelected={onRecentSearchSelected} onNearbyPropertiesSuggestionSelected={onNearbyPropertiesSuggestionSelected} onClose={onForceClosePopover} />
      </PopoverContent>
    </Popover>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");